import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { ScrollText, Reveal } from '../../components/motion';
import styles from './ComingSoon.module.css';

const ClockIcon: React.FC = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.25"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" />
    <polyline points="12 7 12 12 15.5 14" />
  </svg>
);

const ArrowLeftIcon: React.FC = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.25"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </svg>
);

const ComingSoon: React.FC = () => {
  const [params] = useSearchParams();
  const feature = params.get('feature') || 'This page';

  return (
    <section className={styles.wrapper} aria-labelledby="coming-soon-heading">
      <span className={styles.bgBlobOne} aria-hidden="true" />
      <span className={styles.bgBlobTwo} aria-hidden="true" />
      <span className={styles.gridOverlay} aria-hidden="true" />

      <Container fluid="xl" className={styles.inner}>
        <Reveal as="span" className={styles.eyebrow} direction="scale">
          <ClockIcon />
          <span>{feature}</span>
        </Reveal>

        <ScrollText
          as="h1"
          id="coming-soon-heading"
          className={styles.heading}
          mode="enter"
        >
          Coming Soon
        </ScrollText>

        <Reveal as="p" className={styles.subhead} delay={0.15}>
          We're putting the finishing touches on this experience. Check back
          shortly &mdash; it&rsquo;s worth the wait.
        </Reveal>

        <Reveal className={styles.actions} delay={0.28}>
          <Link to="/" className={styles.cta}>
            <ArrowLeftIcon />
            <span>Back to Home</span>
          </Link>
        </Reveal>

        <div className={styles.dots} aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </Container>
    </section>
  );
};

export default ComingSoon;
